import { environment } from 'src/environments/environment'
import { Options } from './../models/options'
import {
  EDeliveryName,
  EDeliveryType
} from 'src/app/modules/administration/delivery-list/models/delivery.model'
import { DatePipe } from '@angular/common'
import { IChoToiPheDuyet } from 'src/app/modules/user-profile/profile-overview/profile-overview.component'
import { differenceInCalendarDays } from 'date-fns'
export const isNumber = (num) => {
  return /^\d+$/.test(num)
}

export const formatterInputNumber = (value) =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
export const parserInputNumber = (value) => value.replace(/\$\s?|(,*)/g, '')

export const convertNullToBlank = (params) =>
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === 'null') {
      params[key] = ''
    }
  })

export const renderYearRange = (start: number = 0, end: number = 0) => {
  const data: Options[] = []
  for (let i = start; i < end; i++) {
    data.push({ value: i.toString(), label: i.toString() })
  }
  return data
}

// https://summernote.org/deep-dive/
export const configTextEditor = {
  placeholder: 'Diễn giải...',
  tabsize: 2,
  height: '250px',
  toolbar: [
    ['fontsize', ['fontname', 'fontsize', 'color']],
    ['style', ['bold', 'italic', 'underline', 'clear', 'style', 'height']],
    ['font', ['strikethrough', 'superscript', 'subscript', 'link', 'hr']],
    ['para', ['paragraph', 'ul', 'ol']],
    ['insert', ['table', 'picture']],
    ['misc', ['undo', 'redo']],
    ['view', ['codeview', 'fullscreen']]
  ],
  fontSizes: [
    '8',
    '9',
    '10',
    '11',
    '12',
    '14',
    '18',
    '24',
    '36',
    '44',
    '56',
    '64',
    '76',
    '84',
    '96'
  ],
  fontNames: [
    'Arial',
    'Times New Roman',
    'SKODANext',
    'Inter',
    'Comic Sans MS',
    'Courier New',
    'Roboto'
  ]
  // fontNames: ['Arial', 'Times New Roman', 'SKODANext', 'Inter', 'Comic Sans MS', 'Courier New', 'Roboto', 'MangCau', 'BayBuomHep','BaiSau','BaiHoc','CoDien','BucThu', 'KeChuyen', 'MayChu', 'ThoiDai', 'ThuPhap-Ivy', 'ThuPhap-ThienAn']
}

/**
 * Remove field null
 * @param obj
 * @returns
 */
export const removeEmpty = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v != null && v != '')
  )
}

/**
 * Eg: 2020 curent
 * this.years(5,5) => [2015,...2025]
 * @param startYear
 * @returns
 */
export const years = (start: number = 5, end: number = 5) => {
  const years: any[] = []
  const endYear = new Date().getFullYear() + end
  let startYear = new Date().getFullYear() - start
  while (startYear <= endYear) {
    years.push(startYear++)
  }
  return years
}

/**
 * this.firstAndLastDayOfMonth('2021', '9')
 * @param year
 * @param month
 * @returns
 */
export const firstAndLastDayOfMonth = (year: string, month: string) => {
  let date = null

  if (year && month) {
    date = new Date().setFullYear(Number(year))
    date = new Date(date).setMonth(Number(month) - 1)
  }

  if (year && !month) {
    date = new Date().setFullYear(Number(year))
  }

  if (!year && month) {
    date = new Date().setMonth(Number(month) - 1)
  }

  // Start date of the month
  let first_date = new Date(date) //Make a copy of the date we want the first and last days from
  first_date.setUTCDate(1) //Set the day as the first of the month

  // End date of the month
  let last_date = new Date(first_date) //Make a copy of the calculated first day
  last_date.setUTCMonth(last_date.getUTCMonth() + 1) //Add a month
  last_date.setUTCDate(0) //Set the date to 0, this goes to the last day of the previous month

  // const date = new Date();
  // const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  // const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  // NOTE: new Date(new Date().getFullYear(), 11, 31)  // Final day of the year

  return { firstDate: first_date, lastDate: last_date }
}

/**
 * <div #scollEl/>
 * this.scrollEl(scollEl, 500);
 * @param el
 * @param timeout
 */
export const scrollEl = (el?: HTMLElement, timeout = 0, focusInput = false) => {
  if (timeout) {
    setTimeout(() => {
      el && el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      focusInput && el.focus()
    }, timeout)
  } else {
    el && el.scrollIntoView()
    focusInput && el.focus()
  }
}

/**
 * Trim string from the dynamic object
 * @param obj
 * @returns
 */
export const getTrimmedData = (obj) => {
  if (obj && !(obj instanceof FormData)) {
    if (obj && typeof obj === 'object') {
      Object.keys(obj).map((key) => {
        if (typeof obj[key] === 'object') {
          getTrimmedData(obj[key])
        } else if (typeof obj[key] === 'string') {
          obj[key] = obj[key].trim()
        }
      })
    }
  }
  return obj
}

/**
 * Id radom
 * @returns
 */
export const numberId = () =>
  new Date().getTime() + Math.floor(Math.random() * 1000)

/**
 * Convert null or number
 * @param number
 * @returns
 */
export const nullOrNumberOnly = (number) =>
  number === '' || number === undefined || number === null
    ? null
    : Number(number)

export const authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`
export const HEADER_ACCEPT = { headers: { Accept: 'application/json' } }
export const odooInfo = `${environment.appVersion}-${environment.USERDATA_KEY}-odoo`
export const workLocalInfo = `${environment.appVersion}-${environment.USERDATA_KEY}-workInfo`
export const recoverAttemptKey = `${authLocalStorageToken}-recover-attempt`

/**
 * @description Đường dẫn trang đăng nhập của portal.
 * @description `selectAccount` dùng khi cần người dùng đăng nhập bằng TÀI KHOẢN KHÁC:
 * @description vì đăng xuất cục bộ không huỷ session SSO ở Azure AD nên lần đăng nhập
 * @description kế tiếp sẽ tự động vào lại đúng tài khoản cũ - nếu chính tài khoản đó là
 * @description nguyên nhân lỗi thì người dùng rơi vào vòng lặp không thoát ra được.
 */
export const LOGIN_PATH = '/auth/login'
export const LOGIN_PATH_SELECT_ACCOUNT = `${LOGIN_PATH}?selectAccount=1`

/**
 * @description Trang báo không đủ quyền truy cập.
 */
export const FORBIDDEN_PATH = '/error/403'

/**
 * @description Xoá dữ liệu phiên đăng nhập của RIÊNG portal khỏi storage.
 * @description KHÔNG được dùng localStorage.clear()/sessionStorage.clear(): storage dùng
 * @description chung theo origin nên clear() sẽ xoá luôn dữ liệu của các ứng dụng khác
 * @description được host cùng domain. Cache của MSAL không xoá ở đây - việc đó do
 * @description msalService.logoutRedirect() lo, kể cả khi đăng xuất cục bộ.
 * @return void
 */
export const clearPortalSession = (preserveReturnUrl: boolean = false): void => {
  const savedReturnUrl = preserveReturnUrl ? sessionStorage?.getItem(returnUrlKey) : null;

  [authLocalStorageToken, odooInfo, workLocalInfo, 'signalrConnectionId'].forEach(
    (key) => localStorage.removeItem(key)
  )
  sessionStorage.removeItem(recoverAttemptKey)
  sessionStorage.removeItem(returnUrlKey)

  if (savedReturnUrl) {
    sessionStorage.setItem(returnUrlKey, savedReturnUrl)
  }
}

/**
 * @description Nơi giữ trang người dùng đang muốn vào khi bị chen ngang bởi đăng nhập.
 * @description Dùng sessionStorage: đích quay lại thuộc về ĐÚNG tab đang mở, không được
 * @description rò sang tab khác của cùng trình duyệt.
 */
export const returnUrlKey = `${authLocalStorageToken}-return-url`

/**
 * @description Các route hạ tầng, không bao giờ được dùng làm đích quay lại.
 * @description Quay về đây sau khi đăng nhập sẽ tạo vòng lặp hoặc rơi vào trang trắng.
 */
const nonReturnableRoutes = ['/callbackmsal', '/callback', '/auth', '/error']

/**
 * @description Ghi nhớ trang người dùng đang muốn vào, trước khi chuyển họ sang Azure AD.
 * @description Cần thiết vì msal đang đặt navigateToLoginRequestUrl: false - sau khi đăng
 * @description nhập, MSAL trả người dùng về redirectUri (/callbackmsal) chứ KHÔNG về URL
 * @description ban đầu. Không tự lưu thì mọi link gửi qua mail đều rơi về trang chủ.
 * @param url: string đường dẫn nội bộ, ví dụ '/personnel/rest-overtime?id=1'
 * @return void
 */
export const saveReturnUrl = (url: string): void => {
  const target = url?.trim()

  /**
   * Chỉ chấp nhận đường dẫn nội bộ. Loại '//host' vì đó là URL protocol-relative:
   * trình duyệt hiểu là sang tên miền khác, đủ để thành lỗ hổng open redirect.
   */
  if (!target || !target.startsWith('/') || target.startsWith('//')) {
    return
  }

  const isNonReturnable = nonReturnableRoutes.some(
    (route) => target === route || target.startsWith(`${route}/`) || target.startsWith(`${route}?`)
  )
  if (target === '/' || isNonReturnable) {
    return
  }

  sessionStorage.setItem(returnUrlKey, target)
}

/**
 * @description Lấy ra đích quay lại và XOÁ ngay - đích chỉ dùng đúng một lần.
 * @description Không xoá thì lần đăng nhập sau người dùng lại bị ném về trang cũ.
 * @param fallback: string đích mặc định khi không có gì được lưu
 * @return string
 */
export const takeReturnUrl = (fallback: string = '/'): string => {
  const url = sessionStorage.getItem(returnUrlKey)
  sessionStorage.removeItem(returnUrlKey)
  return url || fallback
}

export const getStatusContent = (status: string, statusOptions: any) => {
  const currentStatus = statusOptions.find(
    (statusOption: any) => statusOption.value === status
  )

  return {
    label: currentStatus?.label ?? '',
    className: currentStatus?.className ?? ''
  }
}

export const dateConvert = (dateStr: string) => {
  if (!dateStr) return null

  const [dateAnalyst, timeAnalyst] = dateStr.split(' ')

  if (dateAnalyst?.indexOf('/') >= 0) {
    const [day, month, year] = dateAnalyst?.split('/');
    if (timeAnalyst) {
      const [hour, minutes, seconds] = timeAnalyst?.split(':');
      return new Date(+year, (+month) - 1, +day, +hour, +minutes, +seconds)
    }
    return new Date(+year, (+month) - 1, +day)
  }

  if (dateAnalyst?.indexOf('-') >= 0) {
    const [year, month, day] = dateAnalyst?.split('-');
    if (timeAnalyst) {
      const [hour, minutes, seconds] = timeAnalyst?.split(':');
      return new Date(+year, (+month) - 1, +day, +hour, +minutes, +seconds)
    }
    return new Date(+year, (+month) - 1, +day)
  }

  return null
}

export const createDataApproveHoliday = (value = []) => {
  let dataItem = []
  value?.forEach((item) => {
    const dataMonth = item?.data ?? []
    dataMonth?.forEach((m) => {
      dataItem.push({
        ID: m.id,
        EMPLOYEENAME: m.employee,
        TIMECREATE: dateConvert(m.time_create),
        LEAVEFROM: m.date_from,
        LEAVETO: m.date_to,
        // TYPELEAVE: m.type,
        REMARK: m.remark ?? '',
        NOTE: m.note ?? '',
        TIMEAPPROVE: dateConvert(m.time),
        STATUS: m.action,
        MODEL: m.model
      })
    })
  })

  return dataItem
}

export const createDataApproveRegisterStationery = (value = []) => {
  let dataItem = []
  value?.forEach((item) => {
    const dataMonth = item?.data ?? []
    dataMonth?.forEach((m) => {
      dataItem.push({
        ID: m.id,
        MANAGER: m.manager,
        EMPLOYEENAME: m.employee,
        TIMECREATE: dateConvert(m.date_register_stationery),
        TIMEAPPROVE: dateConvert(m.time),
        DEPARTMENT: m.department,
        NOTE: m.note ?? '',
        STATUS: m.action,
        MODEL: m.model
      })
    })
  })

  return dataItem
}

export const createDataApproveRegisterVehicle = (value = []) => {
  let dataItem = []
  value?.forEach((item) => {
    const dataMonth = item?.data ?? []
    dataMonth?.forEach((m) => {
      dataItem.push({
        ID: m.id,
        MANAGER: m.manager,
        EMPLOYEENAME: m.employee,
        TIMECREATE: dateConvert(m.date_register_bus),
        TIMEAPPROVE: dateConvert(m.time),
        DATEDEPARTURE: dateConvert(m.date_departure),
        DATEBACK: dateConvert(m.date_back),
        PASSENGER: (m.accompany_ids as any[])?.map((m) => m.name).join('\n'),
        CARTYPE: m.car_type ? m.car_type : 'Thiếu thông tin xe',
        STATUS: m.action,
        MODEL: m.model
      })
    })
  })

  return dataItem
}

const getDeliveryTypeOptions = (
  expressDeliveryType: EDeliveryType | string
) => {
  switch (expressDeliveryType) {
    case EDeliveryType.NORMAL_EXPRESS:
      return EDeliveryName.NORMAL_EXPRESS
    case EDeliveryType.SUPPER_EXPRESS:
      return EDeliveryName.SUPPER_EXPRESS
    // case EDeliveryType.PARCEL:
    //   return EDeliveryName.PARCEL
    case EDeliveryType.HAND_EXPRESS:
      return EDeliveryName.HAND_EXPRESS
    case EDeliveryType.HIGH_VALUE_EXPRESS:
      return EDeliveryName.HIGH_VALUE_EXPRESS
    case EDeliveryType.NORMAL_VALUE_EXPRESS:
      return EDeliveryName.NORMAL_VALUE_EXPRESS
    default:
      return expressDeliveryType
  }
}

export const createDataApproveExpressDelivery = (value = []) => {
  let dataItem = []
  value?.forEach((item) => {
    const dataMonth = item?.data ?? []
    dataMonth?.forEach((m) => {
      dataItem.push({
        ID: m.id,
        MANAGER: m.manager,
        EMPLOYEENAME: m.employee,
        TIMECREATE: m.date_register_express,
        TIMEAPPROVE: dateConvert(m.time),
        DELIVERYTYPE: getDeliveryTypeOptions(m.delivery_type),
        RECIPIENTNAME: m.recipient_name,
        SENDERNAME: m.sender_name,
        CPN: m.code_cpn,
        STATUS: m.action,
        MODEL: m.model
      })
    })
  })

  return dataItem
}

export const createDataApproveExplain = (value = []) => {
  let dataItem = []
  value?.forEach((item) => {
    const dataMonth = item?.data ?? []
    dataMonth?.forEach((m) => {
      dataItem.push({
        ID: m.id,
        EMPLOYEENAME: m.employee,
        WORKINGDAY: dateConvert(m.time ?? m.date),
        FROMHOUR: m.time
          ?? parseFloatTimeToTimeObj(dateConvert(m.time ?? m.date), m.check_in, false),
        TOHOUR: m.time
          ?? parseFloatTimeToTimeObj(dateConvert(m.time ?? m.date), m.check_out, false),
        MANUAL_CODE: m.name,
        NOTE: m.note ?? '',
        STATUS: m.action,
        MODEL: m.model,
        REMARK: m.remark ?? ''
      })
    })
  })

  return dataItem
}

export const createDataApproveOT = (value = []) => {
  let dataItem = []
  value?.forEach((item) => {
    const dataMonth = item?.data ?? []
    dataMonth?.forEach((m) => {
      dataItem.push({
        ID: m.id,
        EMPLOYEENAME: m.employee,
        MANAGER: m.manager,
        TIMECREATE: m.start_date,
        FROMDATE: m.from_date,
        TODATE: m.to_date,
        FROMHOUR_TOHOUR: m.from_hour_to_hour,
        FROMHOUR_TOHOUR_TOTAL: m.from_hour_to_hour_total,
        NOTE: m.note ?? '',
        REMARK: m.remark ?? '',
        TIMEAPPROVE: dateConvert(m.time),
        MODEL: m.model,
        STATUS: m?.action
      })
    })
  })

  return dataItem
}

export const createDataApproveMeetingRoom = (value = []) => {
  let dataItem = [];
  (<any[]>value).forEach(item => {
    const dataMonth = item?.data ?? [];
    (<any[]>dataMonth).map(m => {
      dataItem.push({
        ID: m.id,
        MANAGER: m.manager,
        EMPLOYEENAME: m.employee,
        TIMECREATE: dateConvert(m.date_register_stationery),
        TIMEAPPROVE: dateConvert(m.time),
        DEPARTMENT: m.department,
        NAME: m.name ?? '',
        STATUS: m.action,
        MODEL: m.model,
      })
    })
  })

  return dataItem;
}

export const createDataListGoingBusiness = (value = []) => {
  let dataItem = [];
  (<any[]>value).forEach(item => {
    const dataMonth = item?.data ?? [];
    (<any[]>dataMonth).map(m => {
      dataItem.push({
        ID: m.id,
        MANAGER: m.manager,
        EMPLOYEENAME: m.employee,
        TIMEAPPROVE: dateConvert(m.time),
        FROMDATE: dateConvert(m.date_from),
        TODATE: dateConvert(m.date_to),
        NAME: m.name ?? '',
        STATUS: m.action,
        MODEL: m.model,
      })
    })
  })

  return dataItem;
}

/**
 * parse float time to time object
 * @param date date target
 * @param timeStr time string data
 * @param toTimeStr result is time string else time object
 * @returns time string or time object
 */
export const parseFloatTimeToTimeObj = (date: any, timeStr: number, toTimeStr: boolean = true) => {
  let hours = Math.round(Number(timeStr));
  let minutes = Math.round((Number(timeStr) - hours) * 60);
  let seconds = Math.round((((Number(timeStr) - hours) * 60) - minutes) * 60);
  let dateObj = new Date(date);
  dateObj.setHours(hours);
  dateObj.setMinutes(minutes);
  dateObj.setSeconds(seconds);
  if (!toTimeStr) return dateObj;
  return dateObj.toLocaleTimeString('vi', { hour: '2-digit', minute: '2-digit' });
}

export const getStartEndDateInCurrentWeek = (dateNow: Date) => {
  const startOfWeek = new Date(dateNow); // Create a new date object
  const endOfWeek = new Date(dateNow); // Create another date object

  startOfWeek.setHours(0, 0, 0, 0); // Set the time to the start of the day
  startOfWeek.setDate(dateNow.getDate() - dateNow.getDay() + 1); // Set the date to the start of the week

  endOfWeek.setHours(23, 59, 59, 999); // Set the time to the end of the day
  endOfWeek.setDate(dateNow.getDate() + (6 - dateNow.getDay() + 1)); // Set the date to the end of the week

  return [startOfWeek, endOfWeek]
}

export const getHRApproveQty = (job: IChoToiPheDuyet) => {
  return (job?.leave ?? 0) + (job?.overtime ?? 0)
    + (job?.timesheet ?? 0) + (job?.list_going_on_business ?? 0)
}

export const getAdministratorApproveQty = (job: IChoToiPheDuyet) => {
  return /*(job?.express_delivery ?? 0) + */(job?.shuttle_bus ?? 0) + (job?.register_stationery ?? 0)
  // + (job?.synthetic_stationery ?? 0)// + (job?.meeting_room ?? 0)
}

export const getOtherApproveQty = (job: IChoToiPheDuyet) => {
  return 0//(job?.all ?? 0) - getHRApproveQty(job) - getAdministratorApproveQty(job)
}

export const range = (start: number, end: number) => {
  const result: number[] = []
  for (let i = start; i < end; i++) {
    result.push(i)
  }
  return result
}

export const defaultImagePath = 'data:image/png;base64,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'


export const convertNonAccentLowerCase = (str) => {
  str = str.toLowerCase()

  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
  str = str.replace(/đ/g, 'd')

  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '') // Huyền sắc hỏi ngã nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, '') // Â, Ê, Ă, Ơ, Ư
  return str
}

export const convertNonAccentUpperCase = (str) => {
  str = str.toUpperCase()

  str = str.replace(/A|Á|À|Ã|Ạ|Â|Ấ|Ầ|Ẫ|Ậ|Ă|Ắ|Ằ|Ẵ|Ặ/g, 'A')
  str = str.replace(/E|É|È|Ẽ|Ẹ|Ê|Ế|Ề|Ễ|Ệ/, 'E')
  str = str.replace(/I|Í|Ì|Ĩ|Ị/g, 'I')
  str = str.replace(/O|Ó|Ò|Õ|Ọ|Ô|Ố|Ồ|Ỗ|Ộ|Ơ|Ớ|Ờ|Ỡ|Ợ/g, 'O')
  str = str.replace(/U|Ú|Ù|Ũ|Ụ|Ư|Ứ|Ừ|Ữ|Ự/g, 'U')
  str = str.replace(/Y|Ý|Ỳ|Ỹ|Ỵ/g, 'Y')
  str = str.replace(/Đ/g, 'D')
  // Some system encode vietnamese combining accent as individual utf-8 characters
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '') // Huyền sắc hỏi ngã nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, '') // Â, Ê, Ă, Ơ, Ư
  return str
}

/**
 * scroll selector menu to top
 * @param KTUtil layout config
 * @param selector selector element
 */
export const handleScrollMenuToTop = (KTUtil, selector) => {
  // move scroll noti to top
  const offContentArea = KTUtil.getByClass(selector)
  if (offContentArea && offContentArea.length > 0) {
    offContentArea[0].scrollTop = 0
  }
}

/**
     * check date in calendar disabled or enabled
     * @param dateCurrentInCalendar date in calendar
     * @param TODATE the end of date
     * @returns 
     */
export const checkDisabledStartDate = (dateCurrentInCalendar, TODATE): boolean => {
  if (TODATE) {
    const toDate = new Date(TODATE)
    toDate.setHours(0)
    toDate.setMinutes(0)
    toDate.setSeconds(0)
    if (differenceInCalendarDays(dateCurrentInCalendar, toDate) > 0) {
      return true
    }
    return false
  }

  return false
}

/**
* check date in calendar disabled or enabled
* @param dateCurrentInCalendar date in calendar
* @param FROMDATE the start of date
* @returns 
*/
export const checkDisabledEndDate = (dateCurrentInCalendar, FROMDATE): boolean => {
  if (FROMDATE) {
    const fromDate = new Date(FROMDATE)
    fromDate.setHours(0)
    fromDate.setMinutes(0)
    fromDate.setSeconds(0)

    if (differenceInCalendarDays(dateCurrentInCalendar, fromDate) < 0) {
      return true
    }
    return false
  }

  return false
}

export const onBeforePrintWithoutApprover = (timelineApproverQL) => {
  timelineApproverQL.toArray().forEach(ql => {
    const timelineApproverRef = ql.nativeElement
      if (!timelineApproverRef.classList.contains('timeline_approver')) {
        timelineApproverRef.classList.add('timeline_approver')
      }
  })
  window.print()
}

export const onAfterPrintWithoutApprover = (timelineApproverQL) => {
  timelineApproverQL.toArray().forEach(ql => {
    const timelineApproverRef = ql.nativeElement
    timelineApproverRef.classList.remove('timeline_approver')
  })
}

export const replaceDescriptionToHTMLData = (description = '') => {
  return description.split(/\n/).join("<br>")
}

export const convertFAIcon = (value: string, icon: string) => {
  let iconReplace = null;
  switch(icon) {
    case "fa-long-arrow-right":
      iconReplace = "fa-long-arrow-alt-right"
      break;
    default:
      iconReplace = icon
      break;
  }
  return value.replace(icon, iconReplace)
}

export const linkMobileApp = 'https://download.thanhcong.vn/skoda/eoffice/qrcode'

export const assistantMails = ['troly.hongngoc@thanhcong.vn', 'testsso@thanhcong.vn', 'testsso@skoda-vietnam.vn', 'hoant@skoda-vietnam.vn']

export const sumissionMenuTitle = 'MENU.REPORT.REPORT'

export const tcgDocumentMenuTitle = 'MENU.TCG_DOCUMENT'